// Общие константы и функции для фильтрации разделов и подразделов объекта

export const normalizePurposeName = (name) =>
    (name || "")
        .toString()
        .trim()
        .toLowerCase()
        .replace(/\s+/g, " ");

// Разделы объекта, которые нужно исключить
export const OBJECT_SECTION_EXCLUDE = new Set([
    "\"test\"",
    "test",
    "коммунальные объекты",
    "население",
    "нет выбора",
    "образовательные объекты",
    "объекты водоснабжения",
    "оздоровительные учреждения",
    "пищевые предприятия",
    "почвенные зоны",
    "промышленные предприятия",
    "территориальные объекты",
    "транспорт",
]);

// Названия разделов, для которых нужна специальная фильтрация подразделов
export const OUTBREAK_SECTION_NAME = "очаги";
export const EPIDEMIOLOGICAL_DEPARTMENT_SECTION_NAME = "эпидемиологический отдел";

// Подразделы, которые разрешены для разделов "Очаги" и "Эпидемиологический отдел"
export const OUTBREAK_SUBSECTION_ALLOWED = new Set([
    "домашние очаги",
    "организованные очаги",
    "эпид.мониторинг(внешняя среда)",
    "контактный",
]);

// Подразделы, для которых нужно показывать поле "Подподраздел объекта"
export const OUTBREAK_SUBSECTION_WITH_SUBSUBSECTION = new Set([
    "домашние очаги",
    "организованные очаги",
    "эпид.мониторинг(внешняя среда)",
    "контактный",
]);

// Опции для поля "Подподраздел объекта"
export const OUTBREAK_SUBSUBSECTION_OPTIONS = [
    "Холера",
    "Брюшной тиф",
    "Паратиф А.В.С",
    "Носительство возбудителя брюшного тифа",
    "Другие сальмонеллезные инфекции",
    "Бактериальная дизентерия",
    "Шигеллез бактериально подтвержденный",
    "Носительство возбудителей дизентерии",
    "Другие кишечные инфекции уточненные",
    "Бактериальные и вирусные кишечные инфекции неуточненные",
    "Ротавирусный энтерит",
    "Группа острых кишечных инфекций",
    "Энтериты вызванные иерсиния энтероколитика",
    "Функциональная диарея",
    "Другие бактериальные пищевые отравления",
    "в том числе  ботулизм",
    "Чума",
    "Туляремия",
    "Сибирская язва",
    "Бруцеллез, впервые диагностированный",
    "Пастереллез",
    "Лептоспироз",
    "Листериоз",
    "Болезнь легионеров",
    "Дифтерия",
    "Носительство возбудителей дифтерии",
    "Коклюш",
    "Скарлатина",
    "Менингококковая инфекция",
    "Менингит гнойный",
    "Менингит серозный",
    "Гемофильная инфекция типа b",
    "Столбняк новорожденного",
    "Другие формы столбняка",
    "Болезнь, вызванная вирусом иммунодефицита человека (ВИЧ)",
    "Полиомиелит острый",
    "Острый вялый паралич",
    "Ветряная оспа",
    "Корь",
    "Краснуха",
    "Синдром врожденной краснухи",
    "Клещевой вирусный энцефалит",
    "Геморрагические лихорадки",
    "В том числе Конго-Крымская геморрагическая лихорадка",
    "В том числе геморрагическая лихорадка с почечным синдромом",
    "В том числе лихорадка Денге",
    "Острые вирусные гепатиты всего",
    "в том  числе гепатит А",
    "в том  числе гепатит В",
    "в том  числе гепатит D",
    "в том числе  гепатит С",
    "в том числе  гепатит Е",
    "Хронические вирусные гепатиты, впервые выявленные",
    "в том числе  хронический вирусный гепатит В с дельта",
    "Хронический вирусный гепатит В без дельта",
    "Хронический вирусный гепатит С",
    "Бешенство",
    "Паротит эпидемический",
    "Риккетсиозы",
    "В том числе  эпидемический сыпной тиф",
    "Клешевой сыпной тиф",
    "Лихорадка Ку",
    "Иерсиниозы",
    "Болезнь Лайма",
    "Малярия впервые диагностированная",
    "Паразитоносители малярии",
    "Висцеральный лейшманиоз",
    "Кожный лейшманиоз",
    "Эхинококкоз",
    "Альвеококкоз",
    "Трихинеллез",
    "Аскаридоз",
    "Гименолепидоз",
    "Энтеробиоз",
    "Амебиаз",
    "Лямблиоз",
    "Токсоплазмоз",
    "Трихоцефалез",
    "Стронгилоидоз",
    "Токсокароз",
    "Тениаринхоз",
    "Тениоз",
    "Дифиллоботриоз",
    "Дирофиляриоз",
    "Анкилостомидоз",
    "Другие трематодозы",
    "В  том числе описторхоз",
    "Острая инфекция верхних дыхательных путей неуточненная",
    "Грипп",
    "Туберкулез",
    "В том числе органов дыхания",
    "В том числе с бактериовыделением (БК+)",
    "Сифилис",
    "Чесотка",
    "Дерматомикозы",
    "Педикулез",
    "Инфекционные болезни,специфичные для перинатального периода",
    "Осложнения, связанные преимущественно с послеродовым периодом",
    "Осложнения хирургических и терапевтических вмешательств",
    "Коронавирусная инфекция, вирус идентифицирован",
    "Коронавирусная инфекция, вирус не идентифицирован",
    "Коронавирусная инфекция не уточненная",
].map((name) => ({ id: name, name }));

// Функция для проверки, нужно ли показывать поле "Подподраздел объекта"
export const shouldShowSubSubSection = (selectedSubSectionName) => {
    return OUTBREAK_SUBSECTION_WITH_SUBSUBSECTION.has(
        normalizePurposeName(selectedSubSectionName)
    );
};

// Функция для фильтрации разделов объекта
export const filterObjectSection = (option) => {
    const normalized = normalizePurposeName(option?.name);
    return !OBJECT_SECTION_EXCLUDE.has(normalized);
};

/** Цели отбора, скрываемые в отчётах и на формах с тем же правилом, что RequestTarificationsQuantityDepartments. */
export const PURPOSE_OF_SELECTION_EXCLUDE = new Set([
    "встречная проверка",
    "комплексная проверка",
    "контрольный закуп",
    "мониторинг",
    "мониторинг окружающей среды",
    "рейдовая проверка",
    "согласование проекта",
    "плановая проверка",
    "профилактический контроль без посещения",
]);

// Функция для фильтрации подразделов объекта
export const filterObjectSubSection = (option, selectedSectionName) => {
    const selectedSection = normalizePurposeName(selectedSectionName);
    
    // Если раздел не "Очаги" и не "Эпидемиологический отдел", показываем все подразделы
    if (selectedSection !== OUTBREAK_SECTION_NAME && 
        selectedSection !== EPIDEMIOLOGICAL_DEPARTMENT_SECTION_NAME) {
        return true;
    }
    
    // Для "Очаги" и "Эпидемиологический отдел" показываем только разрешенные подразделы
    const subsectionName = normalizePurposeName(option?.name);
    return OUTBREAK_SUBSECTION_ALLOWED.has(subsectionName);
};
